module.exports = __webpack_public_path__ + "img/2023big34.4f3ff44e.png";